import { Action } from '@ngrx/store';

export const GET_INSTITUTION_INSURANCES_LIST = '[Institution Insurances] Get Institution Insurances List';
export const GET_INSTITUTION_INSURANCES_LIST_SUCCESS = '[Institution Insurances] Get Institution Insurances List Success';
export const GET_INSTITUTION_INSURANCES_LIST_FAIL = '[Institution Insurances] Get Institution Insurances List Failed';

export class GetInstitutionInsurancesList implements Action {
  readonly type = GET_INSTITUTION_INSURANCES_LIST;
  constructor(public payload: any = null) { }
}

export class GetInstitutionInsurancesListSuccess implements Action {
  readonly type = GET_INSTITUTION_INSURANCES_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetInstitutionInsurancesListFail implements Action {
  readonly type = GET_INSTITUTION_INSURANCES_LIST_FAIL;
  constructor(public payload: any = null) { }
}

export type InstitutionInsurancesActions =
  | GetInstitutionInsurancesList
  | GetInstitutionInsurancesListFail
  | GetInstitutionInsurancesListSuccess
  ;